<div class="row-card-container">
  <ng-content></ng-content>
</div>
